import React from "react";
import "./bgBooking.css";
import { NavLink } from "react-router-dom";
const BookNow = () => {
  return (
    <>
      <div className="mt-10">
        <div className="bgBooking h-[545px] flex  flex-col justify-center items-center">
          <div className="md:text-[40px] text-2xl text-center font-normal text-[#ffffff]">
            {" "}
            Experience the Potent Combination <br /> of Luxury and Nature
          </div>
          <div>
            <NavLink
              to="/booking"
              className="flex mt-24 text-white border font-merriweather font-semibold text-base  border-white w-[179px] h-[48px]  justify-center items-center rounded-full hover:bg-white  hover:text-black transition"
            >
              + Book Now
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookNow;
